import React from "react";
import "./empty-page.scss";

const EmptyPage = ({ image, altText = "Empty", EmptySubTitle, imgWidth, fontSize }) => {
  return (
    <div className="empty-container-kl">
      <div className="empty-inner-container-kl">
        <div className="empty-contain-kl">
          <img className="oops-img-kl" src={image} alt={altText}
            style={{ width: imgWidth || "auto" }}
          />
          <div className="empty-sub-title-kl" style={{ fontSize: fontSize || "" }}>
            {EmptySubTitle}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyPage;
